/**
 * CaseManageSlice Extra Reducers
 * 
 * Handles async actions from RTK Query endpoints.
 */

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CaseManageSliceState } from './state';
import { caseEndpoints } from '../endpoints/caseEndpoints';

/**
 * Builds extra reducers for case manage API endpoint matchers.
 */
export function buildCaseManageExtraReducers(builder: ActionReducerMapBuilder<CaseManageSliceState>) {
  builder
    .addMatcher(
      caseEndpoints.endpoints.getCaseManagement.matchFulfilled,
      (state, action) => {
        state.currentCase = action.payload;
        state.isEdited = false;
        state.editedFields = [];
        state.validationErrors = {};
      }
    )
    .addMatcher(
      caseEndpoints.endpoints.updateCaseManagement.matchFulfilled,
      (state, action) => {
        state.currentCase = action.payload;
        state.isEdited = false;
        state.editedFields = [];
        state.validationErrors = {};
      }
    );
}
